var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagSelectedPreview = function SvgTagSelectedPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.866 16.718 7.556-7.585c.532-.532.578-.802.578-1.619V4.585c0-.747-.146-.971-.732-1.557l-1.802-1.796C13.888.646 13.665.5 12.918.5H9.983c-.817 0-1.086.046-1.61.57L.786 8.632c-1.04 1.04-1.056 2.127 0 3.183l4.906 4.895c1.056 1.056 2.142 1.048 3.174.008m2.78-10.321a.923.923 0 0 1-.932-.94c0-.525.401-.933.933-.933.539 0 .94.408.94.932s-.401.94-.94.94"
  })));
};
export default SvgTagSelectedPreview;